/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './order-item-page.component.html';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';
import {OrderEditPageComponent} from './order-edit-page.component';
import {OrderInformationPageComponent} from './order-information-page.component';

import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {OrderModel} from './order-api.service';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED, OrderEditPageComponent, OrderInformationPageComponent],
  selector: 'adn-order-item-page',
  template
})
export class OrderItemPageComponent {
  @Input() state: SignalAdminResourcePageState<OrderModel>;
}
